export default [
  {
    title: "Trang chủ",
    icon: "HomeIcon",
    route: "csm-home",
  },
];
